import React from 'react'

import AceEditor from 'react-ace'
import 'ace-builds/webpack-resolver'

import 'ace-builds/src-noconflict/mode-typescript'
import 'ace-builds/src-noconflict/theme-monokai'

import { Row, Col, Button } from 'react-bootstrap'

import copy from 'copy-to-clipboard'

const ResultsArea = props => {
  const copyToClipboard = () => {
    const editor = document.getElementById('outputEditor').env.editor
    copy(editor.getValue())
  }

  const clear = () => {
    const editor = document.getElementById('outputEditor').env.editor
    editor.setValue('')
  }

  return (
    <div>
      <Row>
        <Col>
          <h5>TypeScript Output</h5>
        </Col>
        <Col className='text-right'>
          <Button
            variant='secondary'
            className='btn-sm'
            onClick={() => clear()}
          >
            Clear
          </Button>
          <Button
            variant='secondary'
            className='btn-sm ml-2'
            onClick={() => copyToClipboard()}
          >
            Copy
          </Button>
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col>
          <AceEditor
            mode='typescript'
            theme='monokai'
            fontSize={14}
            width='100%'
            height='75vh'
            onChange={event => props.handleChange(event)}
            name='outputEditor'
            tabSize={2}
            debounceChangePeriod={500}
            value={props.value}
            editorProps={{ $blockScrolling: true }}
          />
        </Col>
      </Row>
    </div>
  )
}

export default ResultsArea
